import styled from 'styled-components'

export const Wrapper = styled.div``
export const Tile = styled.div`
  display: flex;
  border-radius: 20px;
  border: 1px solid var(--grey-25);

  @media (max-width: 768px) {
    flex-direction: column;
  }
`
export const Image = styled.div`
  background-position: center center;
  background-size: cover;
  width: 260px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;

  @media (max-width: 768px) {
    width: 100%;
    height: 180px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    border-bottom-left-radius: 0;
  }
`
export const Container = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: calc(100% - 260px);
  box-sizing: border-box;

  @media (max-width: 768px) {
    width: 100%;
    padding: 24px;

    & svg {
      width: 36px;
      height: 36px;
    }
  }
`
export const List = styled.ul`
  list-style: disc;
  padding-left: 20px;
  margin-bottom: 0;

  & > li {
    font-weight: var(--font-light);
    line-height: 20px;
  }

  & > li:not(:first-child) {
    margin-top: 10px;
  }
`
